import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import Authenticator from "./components/Authenticator/Authenticator";
import { AppProvider } from "@shopify/polaris";
import enTranslations from "@shopify/polaris/locales/en.json";
import AdapterLink from "./layout/components/AdapterLink";
import { AppErrorBoundary } from "./layout/components/AppErrorBoundary";
import { useAppRouter } from "./layout/hooks/useAppRouter";
import reduxStore from "./redux/store";

import "@shopify/polaris/build/esm/styles.css";
import "./assets/App.scss";

function AppContent() {
  const { router } = useAppRouter();

  return (
    <AppProvider linkComponent={AdapterLink} i18n={enTranslations}>
      <AppErrorBoundary>
        <Authenticator>
          <RouterProvider router={router} />
        </Authenticator>
      </AppErrorBoundary>
    </AppProvider>
  );
}

export default function App() {
  return (
    <Provider store={reduxStore}>
      <AppContent />
    </Provider>
  );
}

